import React, { Component } from 'react';
import Navigation from "../Navigation/Navigation";
import Footer from "../General/Footer";
import { Form, Row, Col, Button } from 'react-bootstrap';
import { Tab, Tabs } from 'react-bootstrap';
import StarRatings from 'react-star-ratings';
import placeholder from "../../assets/badges/blank-profile-picture-973460_960_720.png";
import { Redirect, Link } from 'react-router-dom';
import { getUserProfile, setUserProfile, getMyBookings, getMyRides, getMyRidesBookings, setProfileImage, getTransactions, getStripeDashboardLink } from '../../actions/userProfileActions';
import { connect } from 'react-redux';
import Compressor from 'compressorjs';
import moment from 'moment';
import AlertComponent from '../Alert/alert';
import { getChannel } from '../../actions/chatActions';
import axios from 'axios';

export class RiderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            fullAddress: "",
            idGouvernement: "",
            phoneNumber: "",
            description: "",
            tab: "bookings",
            lockField: true,
            requiredId: false,
            myBookings: [],
            myRides: [],
            myBookedRides: [],
            transactions: [],
            image: "",
            redirectToChat: undefined,
            isLoadingStripeDashboard: false,
            alert: {
                show: false,
                message: "",
                type: ""
            },
            gotoUpdate: {
                go: false,
                ride: {}
            }
        }
        this.onFNameChange = this.onFNameChange.bind(this);
        this.onLNameChange = this.onLNameChange.bind(this);
        this.onAddressChange = this.onAddressChange.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.onDescChange = this.onDescChange.bind(this);
        this.onIdChange = this.onIdChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setTab = this.setTab.bind(this);
        this.renderBookings = this.renderBookings.bind(this);
        this.renderRides = this.renderRides.bind(this);
        this.renderReservations = this.renderReservations.bind(this);
        this.setEditMode = this.setEditMode.bind(this);
        this.sendInfo = this.sendInfo.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);
        this.changeProfilePic = this.changeProfilePic.bind(this);
        this.gotoUpdate = this.gotoUpdate.bind(this);
        this.openStripeDashboard = this.openStripeDashboard.bind(this);
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            let success = this.props.location.state;
            this.setState({
                alert: success.alert
            })
        }
        if (this.props.user && this.props.user.userProfile) {
            getUserProfile({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((res) => {
                if (!res.data) {
                    this.setState({
                        firstName: this.props.user.userProfile.given_name,
                        lastName: this.props.user.userProfile.family_name,
                        lockField: false,
                        requiredId: true
                    })
                }
                else {
                    this.setState({
                        firstName: res.data.firstName,
                        lastName: res.data.lastName,
                        fullAddress: res.data.fullAddress,
                        phoneNumber: res.data.phoneNumber,
                        description: res.data.description,
                        lockField: true,
                        requiredId: false,
                        image: res.data.image
                    })
                }
                getMyBookings({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((resBookings) => {
                    const myBookings = this.formatDesc(resBookings.data);
                    console.log("Réservations: ", myBookings)
                    this.setState({
                        myBookings
                    })
                })
                getMyRides({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((resRides) => {
                    const myRides = this.formatDesc(resRides.data);
                    console.log("Mes rides: ", myRides)
                    this.setState({
                        myRides
                    })
                })
                getMyRidesBookings({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((resRidesBookings) => {
                    const myBookedRides = this.formatDesc(resRidesBookings.data);
                    console.log("Mes locations: ", myBookedRides)
                    this.setState({
                        myBookedRides
                    })
                })
                getTransactions({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((resTransactions) => {
                    if (resTransactions.data === "") {
                        this.setState({
                            transactions: []
                        })
                    }
                    else {
                        console.log("Mes transactions: ", resTransactions.data)
                        this.setState({
                            transactions: resTransactions.data
                        })
                    }
                })
            })
        }
    }

    formatDesc(rides) {
        if (!Array.isArray(rides)) {
            return [];
        }
        rides.forEach((ride) => {
            if (ride.description && typeof ride.description === 'string') {
                try {
                    let descState = JSON.parse(ride.description);
                    if (descState && descState.blocks && descState.blocks[0]) {
                        ride.description = descState.blocks[0].text;
                    }
                } catch (e) {
                    // If parsing fails, keep description as-is
                }
            }
        })
        return rides;
    }

    handleDismiss() {
        this.setState({ alert: { ...this.state.alert, show: false } });
    }

    onFNameChange(data) {
        this.setState({
            firstName: data.target.value
        })
    }

    onLNameChange(data) {
        this.setState({
            lastName: data.target.value
        })
    }

    onAddressChange(data) {
        this.setState({
            fullAddress: data.target.value
        });
    }

    onPhoneChange(data) {
        this.setState({
            phoneNumber: data.target.value
        })
    }

    onDescChange(data) {
        this.setState({
            description: data.target.value
        })
    }

    onIdChange(event) {
        event.preventDefault();
        this.setState({
            idGouvernement: event.target.files[0]
        })
    }

    handleSubmit(data) {
        data.preventDefault();
        let state = this.state;
        let { user } = this.props;
        let self = this;
        if (state.requiredId || state.idGouvernement) {
            new Compressor(this.state.idGouvernement, {
                quality: 0.2,
                success(result) {
                    let formValues = {
                        firstName: state.firstName,
                        lastName: state.lastName,
                        fullAddress: state.fullAddress,
                        idGouvernement: result,
                        phoneNumber: state.phoneNumber,
                        description: state.description,
                        userId: user.userProfile.sub,
                        email: user.userProfile.email
                    }
                    self.sendInfo(formValues);
                }
            })
        }
        else {
            let formValues = {
                firstName: state.firstName,
                lastName: state.lastName,
                fullAddress: state.fullAddress,
                phoneNumber: state.phoneNumber,
                description: state.description,
                userId: user.userProfile.sub,
                email: user.userProfile.email
            }
            this.sendInfo(formValues);
        }
    }

    sendInfo(formValues) {
        const form_data = new FormData()
        for (let key in formValues) {
            form_data.append(key, formValues[key])
        }
        setUserProfile(form_data, this.props.user.token).then((res) => {
            this.setState({
                lockField: true,
                requiredId: false
            })
        }).catch((err) => {
            console.log(err);
        })
    }

    setTab(newTab) {
        if (newTab !== this.state.tab) {
            this.setState({
                tab: newTab
            })
        }
    }

    setEditMode(event) {
        event.preventDefault()
        this.setState({
            lockField: false
        })
    }

    changeProfilePic(event) {
        event.preventDefault();
        let self = this;
        new Compressor(event.target.files[0], {
            quality: 0.2,
            success(result) {
                const form_data = new FormData()
                form_data.append('userId', self.props.user.userProfile.sub)
                form_data.append('image', result)
                setProfileImage(form_data, self.props.user.token).then((res) => {
                    self.setState({
                        image: res.data.imageUrl
                    })
                }).catch((err) => {
                    console.log(err);
                })
            }
        })
    }


    gotoChat(booking) {
        if (this.props.user.userProfile.sub !== booking) {
            getChannel({
                create: false,
                userId: this.props.user.userProfile.sub,
                otherUserId: booking
            }, this.props.user.token).then((res) => {
                this.setState({
                    redirectToChat: res.data
                })
            }).catch((err) => {
                this.setState({
                    alert: {
                        show: true,
                        message: "Vous devez compléter votre profil pour pouvoir discuter.!",
                        type: "danger"
                    }
                }, () => {
                    window.scrollTo(0, 0);
                })
            })
        }
        else {
            this.setState({
                alert: {
                    show: true,
                    message: "Vous ne pouvez pas discuter avec vous-même !",
                    type: "danger"
                }
            }, () => {
                window.scrollTo(0, 0);
            })
        }
    }

    gotoUpdate(rideId) {
        this.setState({
            gotoUpdate: {
                go: true,
                rideId
            }
        })
    }

    openStripeDashboard() {
        console.log('[Stripe Dashboard] Button clicked, attempting to get dashboard link...');

        // Set loading state
        this.setState({ isLoadingStripeDashboard: true });

        // First, try to get the dashboard link
        getStripeDashboardLink(
            { userId: this.props.user.userProfile.sub },
            this.props.user.token
        ).then((res) => {
            console.log('[Stripe Dashboard] Response received:', res);

            // Check if response contains an error (API returned error as success)
            if (res.data && res.data.error) {
                console.log('[Stripe Dashboard] Error in response data, initiating onboarding...');
                throw new Error(res.data.error);
            }

            if (res.data && res.data.dashboardUrl) {
                // Dashboard link exists, open it
                console.log('[Stripe Dashboard] Opening dashboard URL:', res.data.dashboardUrl);
                window.open(res.data.dashboardUrl, '_blank');
                // Reset loading state
                this.setState({ isLoadingStripeDashboard: false });
            } else {
                console.log('[Stripe Dashboard] No dashboardUrl in response, initiating onboarding...');
                throw new Error('No dashboard URL returned');
            }
        }).catch((err) => {
            console.log('[Stripe Dashboard] Catch block triggered');
            console.log('[Stripe Dashboard] Error object:', err);
            console.log('[Stripe Dashboard] Error response:', err.response);

            // Check if it's a 404 error (no Stripe account) or if error message indicates no account
            const is404 = err.response && err.response.status === 404;
            const noAccountError = err.message && err.message.includes('No Stripe Connect account');

            if (is404 || noAccountError) {
                console.log('[Stripe Dashboard] No Stripe account found, initiating onboarding...');

                // Initiate Stripe Connect onboarding
                axios({
                    method: "post",
                    url: process.env.REACT_APP_API_URL + "/api/v1/users/stripe-connect/onboard",
                    data: {
                        userId: this.props.user.userProfile.sub,
                        email: this.props.user.userProfile.email
                    },
                    headers: {
                        "Authorization": `Bearer ${this.props.user.token}`
                    }
                }).then((onboardRes) => {
                    console.log('[Stripe Dashboard] Onboarding response:', onboardRes);
                    if (onboardRes.data && onboardRes.data.accountLink) {
                        // Redirect to Stripe onboarding
                        console.log('[Stripe Dashboard] Redirecting to:', onboardRes.data.accountLink);
                        window.location.href = onboardRes.data.accountLink;
                        // Don't reset loading state here as we're redirecting
                    }
                }).catch((onboardErr) => {
                    console.error('[Stripe Dashboard] Error initiating onboarding:', onboardErr);
                    this.setState({
                        isLoadingStripeDashboard: false,
                        alert: {
                            show: true,
                            message: 'Impossible d\'accéder à la configuration des paiements. Veuillez réessayer plus tard.',
                            type: 'danger'
                        }
                    }, () => {
                        window.scrollTo(0, 0);
                    });
                });
            } else {
                // Some other error occurred
                console.error('[Stripe Dashboard] Unexpected error:', err);
                this.setState({
                    isLoadingStripeDashboard: false,
                    alert: {
                        show: true,
                        message: 'Impossible d\'accéder au tableau de bord des paiements. Veuillez réessayer plus tard.',
                        type: 'danger'
                    }
                }, () => {
                    window.scrollTo(0, 0);
                });
            }
        });
    }

    renderBookings() {
        let bookings = [];
        this.state.myBookings.forEach((booking, index) => {
            if (booking.title && booking.title.length > 22) {
                booking.title = booking.title.substr(0, 22) + "...";
            }
            if (booking.description && booking.description.length > 65) {
                booking.description = booking.description.substr(0, 65) + "...";
            }
            bookings.push(
                <div key={`booking_${booking.ride}_${index}`} className="riderpage__booking__item">
                    <Link to={`/ride/${booking.ride}`}><img src={booking.image} /></Link> {/* Picture of person Booking */}
                    <div className="riderpage__booking__info">
                        <div className="riderpage__booking__name">
                            {booking.title}
                        </div>
                        <div className="riderpage__booking__title">
                            {booking.description}
                        </div>
                        <div className="riderpage__booking__dates">
                            {moment(booking.date[0].split("\"").join("")).format("MMMM D")}
                            {booking.date.length > 1 ? ` - ${moment(booking.date[1].split("\"").join("")).format("MMMM D")}` : ""}
                        </div>
                    </div>
                    <div className="riderpage__booking__actions">
                        <i className="fas fa-comment fa-2x" onClick={() => this.gotoChat(booking.ownerId)}></i> {/* Chat */}
                    </div>
                </div>
            )
        })
        return bookings;
    }

    renderRides() {
        let rides = [];
        this.state.myRides.forEach((ride, index) => {
            if (ride.title && ride.title.length > 22) {
                ride.title = ride.title.substr(0, 22) + "...";
            }
            if (ride.subtitle && ride.subtitle.length > 22) {
                ride.subtitle = ride.subtitle.substr(0, 22) + "...";
            }
            if (ride.description && ride.description.length > 65) {
                ride.description = ride.description.substr(0, 65) + "...";
            }
            rides.push(
                <div key={`booking_${ride.id}_${index}`} className="riderpage__booking__item">
                    <Link to={`/ride/${ride.id}`}><img src={ride.images} /></Link> {/* Picture of person Booking */}
                    <div className="riderpage__booking__info">
                        <div className="riderpage__booking__name">
                            {ride.title}
                        </div>
                        <div className="riderpage__booking__title">
                            {ride.subtitle}
                        </div>
                        <div className="riderpage__booking__dates">
                            {ride.description}
                        </div>
                    </div>
                    <div className="riderpage__booking__actions">
                        <i className="far fa-edit fa-2x" onClick={() => this.gotoUpdate(ride.id)}></i> {/* Update Ride */}
                    </div>
                </div>
            )
        })
        return rides;
    }

    renderReservations() {
        let bookedRides = [];
        this.state.myBookedRides.forEach((bookedRide, index) => {
            if (bookedRide.title && bookedRide.title.length > 22) {
                bookedRide.title = bookedRide.title.substr(0, 22) + "...";
            }
            if (bookedRide.description && bookedRide.description.length > 65) {
                bookedRide.description = bookedRide.description.substr(0, 65) + "...";
            }
            bookedRides.push(
                <div key={`booking_${bookedRide.ride}_${index}`} className="riderpage__booking__item">
                    <Link to={`/ride/${bookedRide.ride}`}><img src={bookedRide.image} /></Link> {/* Picture of person Booking */}
                    <div className="riderpage__booking__info">
                        <div className="riderpage__booking__name">
                            {bookedRide.title}
                        </div>
                        <div className="riderpage__booking__title">
                            {bookedRide.description}
                        </div>
                        <div className="riderpage__booking__dates">
                            {moment(bookedRide.date[0].split("\"").join("")).format("MMMM D")}
                            {bookedRide.date.length > 1 ? ` - ${moment(bookedRide.date[1].split("\"").join("")).format("MMMM D")}` : ""}
                        </div>
                    </div>
                    <div className="riderpage__booking__actions">
                        <i className="fas fa-comment fa-2x" onClick={() => this.gotoChat(bookedRide.bookingUser)}></i> {/* Chat */}
                    </div>
                </div>
            )
        })
        return bookedRides;
    }

    renderTransactions() {
        let transactions = [];
        this.state.transactions.forEach((transaction, index) => {
            transactions.push(
                <div key={`transactions${index}`} className={transaction.type === "PAID" ? "transaction__paid" : "transaction__rev"}>
                    <div>Status: {transaction.status}</div>
                    <div>{transaction.type === "PAID" ? "- " : "+ "}{transaction.totalAmount}$</div>
                </div>
            )
        })
        return transactions;
    }

    render() {
        if (!this.props.user.userProfile) {
            return <Redirect to="/" />
        }
        if (this.state.redirectToChat) {
            return <Redirect to={{
                pathname: "/chat",
                state: {
                    select: this.state.redirectToChat
                }
            }} />
        }
        if (this.state.gotoUpdate.go) {
            return <Redirect to={{
                pathname: "/updateRide",
                state: {
                    rideId: this.state.gotoUpdate.rideId
                }
            }} />
        }
        return (
            <div className="riderpage__main">
                <Navigation auth={this.props.auth} />
                <AlertComponent type={this.state.alert.type} message={this.state.alert.message} show={this.state.alert.show} handleDismiss={this.handleDismiss} />
                <div className="page__hero">
                    <h4 className="page-title page__hero__title">Rider Profile</h4>
                </div>
                <div className="riderpage__container">
                    <div className="riderpage__fields__container">
                        <span className="riderpage__verified"><i className="fas fa-check"></i></span>
                        <div className="riderpage__image">
                            <label htmlFor="profilePic">
                                <img src={this.state.image ? this.state.image : placeholder} />
                            </label>
                            <input id="profilePic" type="file" accept='.jpg, .png, .jpeg' hidden onChange={this.changeProfilePic} />
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <Col>
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Label className="riderpage__name">Prénom</Form.Label>
                                        <Form.Control type="text" name="firstName" value={this.state.firstName}
                                            onChange={this.onFNameChange} placeholder="Prénom" required disabled={this.state.lockField} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Label className="riderpage__name">Nom</Form.Label>
                                        <Form.Control type="text" name="lastName" value={this.state.lastName}
                                            onChange={this.onLNameChange} placeholder="Nom" required disabled={this.state.lockField} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="8">
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Label className="riderpage__name riderpage__location">Adresse <i className="fas fa-map-marker-alt" /></Form.Label>
                                        <Form.Control type="text" name="address" value={this.state.fullAddress}
                                            onChange={this.onAddressChange} placeholder="Adresse" required disabled={this.state.lockField} />
                                    </Form.Group>
                                </Col>
                                <Col sm="4">
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Label className="riderpage__name">Téléphone</Form.Label>
                                        <Form.Control type="text" name="phone" value={this.state.phoneNumber}
                                            onChange={this.onPhoneChange} placeholder="Téléphone" required disabled={this.state.lockField} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Label className="riderpage__name">Description</Form.Label>
                                        <Form.Control type="textarea" name="description" value={this.state.description}
                                            onChange={this.onDescChange} placeholder="Description" disabled={this.state.lockField} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {!this.state.lockField ?
                                <Row>
                                    <Col>
                                        <Form.Group as={Col} controlId="formGridState">
                                            {/* <Field name="image" accept='.jpg, .png, .jpeg' component={FieldFileInput} /> */}
                                            <Form.Label className="riderpage__name">Soumettre identité</Form.Label>
                                            <Form.Control name="image" accept='.jpg, .png, .jpeg' type="file" onChange={this.onIdChange} required={this.state.requiredId} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                :
                                ""
                            }
                            {this.state.lockField ?
                                <Button variant="primary" type="button" onClick={this.setEditMode}>Modifier Profile</Button>
                                :
                                <Button variant="primary" type="submit">Sauvegarder</Button>
                            }

                        </Form>

                        {/* Stripe Connect Dashboard Access for Ride Owners */}
                        {this.state.myRides && this.state.myRides.length > 0 && (
                            <div className="riderpage__stripe-dashboard">
                                <hr />
                                <h5>Tableau de bord des paiements</h5>
                                <p>Consultez vos gains, vos paiements et gérez votre compte de paiement</p>
                                <Button
                                    variant="success"
                                    onClick={this.openStripeDashboard}
                                    disabled={this.state.isLoadingStripeDashboard}
                                    style={{ marginTop: '10px', backgroundColor: '#17a2b8', borderColor: '#17a2b8' }}
                                >
                                    {this.state.isLoadingStripeDashboard ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '8px' }}></span>
                                            Chargement...
                                        </>
                                    ) : (
                                        'Gérer les paiements'
                                    )}
                                </Button>
                            </div>
                        )}
                        {/* <div className="riderpage__grid">
                                <div className="riderpage__rating">
                                    <StarRatings
                                        rating={3}
                                        starRatedColor="#0888be"
                                        starDimension="15px"
                                        starSpacing="0px"
                                    />
                            </div> */}
                        {/* IF LOGGED IN AS OWNER OF THIS RIDE - BOOKINGS ARE HERE */}
                        <div className="riderpage__booking__main">
                            <hr />
                            <div className="profileTabs">
                                <Tabs defaultActiveKey={0}>
                                    <Tab eventKey={0} title="Réservations">
                                        {this.renderBookings()}
                                    </Tab>
                                    <Tab eventKey={1} title="Balades">
                                        {this.renderRides()}
                                    </Tab>
                                    <Tab eventKey={2} title="Locations">
                                        {this.renderReservations()}
                                    </Tab>
                                    <Tab eventKey={3} title="Transactions">
                                        {this.renderTransactions()}
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(RiderPage);
